const colorNotUsed = 'rgba(255, 255, 255, 0.00)';
const colors = {
  base: {
    primary: '#213991',
    secondary: '#1A847D',
    blue300: '#8693C4',
    blue500: '#4B64BD',
    blue800: '#192B6D',
    blueTransparent200: 'rgba(75, 100, 189, 0.12)',
    blueTransparent400: 'rgba(75, 100, 189, 0.24)',
    white: '#FFFFFF',
    whiteTransparent800: 'rgba(255, 255, 255, 0.8)',
    grey50: colorNotUsed,
    grey100: '#F7F8FC',
    grey300: '#E2E7F9',
    grey500: '#D3D7E9',
    grey600: '#9EA1AF',
    grey700: '#0F1C43',
    grey900: '#6A6C75',
    greyTransparent200: colorNotUsed,
    greyTransparent400: colorNotUsed,
    black: '#000000',
  },
  additional: {
    red500: '#D91841',
    red100: '#FFEBEF',
    orange500: '#E36702',
    orange100: '#FFF1E6',
    yellow500: '#FDBE02',
    yellow100: '#FFF2CC',
    green500: '#2BA377',
    green100: '#F0FFF9',
    blue500: '#2C83A8',
    blue200: colorNotUsed,
    blue100: '#F0FAFF',
    teal500: '#2EC0C1',
  },
  text: {
    primary: '#000000',
    secondary: 'rgba(0, 0, 0, 0.66)',
    subtle: 'rgba(0, 0, 0, 0.43)',
    accent: '#0F1C43',
    accentBright: '#1D3381',
    error: '#C1153A',
    reversedPrimary: '#FFFFFF',
    reversedSecondary: 'rgba(255, 255, 255, 0.87)',
  },
  gradients: {
    primary: 'linear-gradient(88deg, #213991 0%, #1A847D 100%)',
    secondary: colorNotUsed,
    tertiary: colorNotUsed,
    notificationCardOverlay: 'linear-gradient(180deg, rgba(247, 248, 252, 0.00) 0%, #F7F8FC 75%)',
  },
  icon: {
    primary: 'rgba(0, 0, 0, 0.92)',
    secondary: 'rgba(0, 0, 0, 0.63)',
    subtle: 'rgba(0, 0, 0, 0.42)',
    primaryHovered: '#000000',
    hoverArea: 'rgba(75, 100, 189, 0.12)',
    accent: '#132353',
    accentBright: '#213991',
    error: '#D91841',
    reversedPrimary: 'rgba(255, 255, 255, 0.96)',
    reversedSecondary: 'rgba(255, 255, 255, 0.84)',
  },
};

const legacyColors = {
  // Layout
  layoutBackgroundPrimary: '#ffffff', // Page base background
  layoutBackgroundSecondary: '#E7EEF3', // Tall header & sidebar background
  layoutBackgroundTertiary: '#E6EBE6', // Additional background
  layoutBackgroundOutside: '#F5F5F5', // Fill color for browser area beyond 1680px width

  // Text colors
  textMainPrimary: '#000000', // Most text blocks, like headers, body texts, descriptions
  textMainSecondary: 'rgba(0, 0, 0, 0.6)', // Secondary texts, hints, component labels
  textMainSubtle: 'rgba(0, 0, 0, 0.25)', // Disabled text. Placeholders
  textAlternatePrimary: '#FFFFFF', // Color style for primery texts over inverted backgrounds
  textAlternateSecondary: 'rgba(255, 255, 255, 0.7)', // Color style for secondary texts over inverted backgrounds
  textErrors: '#FF3A44', // Error description under components

  // UI colors
  uIBase: '#000000', // Dividers. Components strokes
  uIBase2: '#808080', // Reserved
  uIBase4: '#CCCCCC', // Disabled components
  uIBase6: '#F1F1F1', // Components backgrounds
  uIIconBase: 'rgba(0, 0, 0, 0.7)', // Regular state of icons
  uIIconHovered: '#000000',
  uIIconDisabled: 'rgba(0, 0, 0, 0.2)',
  uIIconHoverArea: 'rgba(0, 0, 0, 0.12)', // Hover effects for icons
  uIBlueBase: '#446C88', // Labels
  uIBlueBase2: '#C6DCEC',
  uIBlueBackground: '#E7EEF3', // Components hover states. Backgrounds
  uIGreenBase: '#15CF74', // Labels
  uIGreenBackground: '#E8FAF1', // Background for banners & notifications
  uIYellowBase: '#FFD600', // Labels
  uIYellowBackground: '#FFFBE6', // Background for banners & notifications
  uIRedBase: '#FF3A44', // Labels.Icon-buttons with important actions
  uIRedBackground: '#FFEBEC', // Backgrounds for banners & notifications

  // Focused inputs. Hovered secondary buttons
  uIGradient1: 'linear-gradient(87.99deg, #C3AAB2 0.66%, #99EECC 57.2%, #80C0C8 75.87%, #4B8BFA 98.72%)',
  // Hovered primary buttons
  uIGradient2: 'linear-gradient(68.94deg, #C3AAB2 -4.77%, #99EECC 46.72%, #80C0C8 90.23%, #4B8BFA 134.46%)',
  // Border for panels
  uIGradient3: [
    'radial-gradient(',
    '92.76% 76.25% at 7.24% 21%, #B5D39D 0%, #F1ACAC 25.66%, #BF98C6 54.47%, #7179EF 86.04%, #2833D0 100%',
    ') 1'].join(''),
  // Gradient for Notifications
  uIGradient4: 'linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',

  // Dropdown menus
  dropmenuBackground: '#FFFFFF', // Menu background
  dropmenuHover: '#E7EEF3',
  dropmenuSelected: '#F1F1F1', // Selected options in menu

  // Footer
  footerBackground: '#000000',
  footerUIElements: '#FFFFFF',
  footerTextPrimary: '#FFFFFF',
  footerTextSecondary: 'rgba(255, 255, 255, 0.7)',

  // Loader
  loaderBody: '#000000',
  loaderBackground: '#FFFFFF',
  loaderOverlay: 'rgba(255, 255, 255, 0.8)',
  loaderRotationUnit: '#2EC0C1',

  // focus
  focusOutline: '#1751C1',
};

const borders = {
  radius3: 18,
  radius2: 12,
  radius1: 6,
  radiusHalfBlock: 3,
  radiusZero: 0,
};

const shadows = {
  dropShadow200: '0px 4px 15px 0px rgba(32, 61, 149, 0.14)',
  dropShadow400: '0px 8px 20px 0px rgba(32, 61, 149, 0.10)',
};

const layout = {
  backgroundPrimary: colors.base.white,
  backgroundSecondary: colors.base.grey100,
  backgroundTertiary: colorNotUsed,
  backgroundOutside: colors.base.grey100,
  divider700: colors.base.grey700,
  divider500: colors.base.primary,
  divider300: colors.base.grey500,
  contentAreaShadow: shadows.dropShadow400,
  dialogOverlay: 'rgba(106, 108, 117, 0.50)',
};

const spacing = 6;

export const OSDefaultLight = {
  spacing,
  fonts: [
    {
      fontFamily: 'NotoSans-Regular',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'NotoSans-Regular.ttf',
      fontFormat: 'truetype',
    },
    {
      fontFamily: 'NotoSans-Medium',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'NotoSans-Medium.ttf',
      fontFormat: 'truetype',
    },
    {
      fontFamily: 'NotoSans-SemiBold',
      fontStyle: 'normal',
      fontWeight: 400,
      fontName: 'NotoSans-SemiBold.ttf',
      fontFormat: 'truetype',
    },
  ],
  typography: {
    h1: {
      fontFamily: 'NotoSans-Medium',
      fontSize: '54px',
      lineHeight: '72px',
    },
    h2: {
      fontFamily: 'NotoSans-Medium',
      fontSize: '38px',
      lineHeight: '48px',
    },
    h3: {
      fontFamily: 'NotoSans-Medium',
      fontSize: '30px',
      lineHeight: '42px',
    },
    h4: {
      fontFamily: 'NotoSans-Medium',
      fontSize: '26px',
      lineHeight: '36px',
    },
    h5: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '18px',
      lineHeight: '24px',
    },
    h6: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '16px',
      lineHeight: '24px',
    },
    h7: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '12px',
      lineHeight: '18px',
    },
    textBig: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '18px',
      lineHeight: '24px',
    },
    textBigCompact: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '18px',
      lineHeight: '18px',
    },
    textRegular: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '16px',
      lineHeight: '24px',
    },
    textRegularCompact: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '16px',
      lineHeight: '18px',
    },
    textSmall: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '14px',
      lineHeight: '24px',
    },
    textSmallCompact: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '14px',
      lineHeight: '18px',
    },
    textTiny: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '12px',
      lineHeight: '18px',
    },
    textTinyCompact: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '12px',
      lineHeight: '12px',
    },
    accentXL: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '26px',
      lineHeight: '36px',
    },
    accentBig: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '18px',
      lineHeight: '24px',
    },
    accentBigCompact: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '18px',
      lineHeight: '28px',
    },
    accentRegular: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '16px',
      lineHeight: '24px',
    },
    accentRegularCompact: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '16px',
      lineHeight: '28px',
    },
    accentSmall: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '14px',
      lineHeight: '24px',
    },
    accentSmallCompact: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '14px',
      lineHeight: '18px',
    },
    accentTiny: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '12px',
      lineHeight: '18px',
    },
    accentTinyCompact: {
      fontFamily: 'NotoSans-SemiBold',
      fontSize: '12px',
      lineHeight: '12px',
    },
    linkRegular: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '16px',
      lineHeight: '24px',
      textDecoration: 'underline',
    },
    linkSmall: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '14px',
      lineHeight: '24px',
      textDecoration: 'underline',
    },
    linkTiny: {
      fontFamily: 'NotoSans-Regular',
      fontSize: '12px',
      lineHeight: '18px',
      textDecoration: 'underline',
    },
  },
  borders,
  shadows,
  flags: {
    boxStyle: 'full',
    showIcons: true,
  },
  colors: {
    ...legacyColors,
    layout,
    text: colors.text,
    base: colors.base,
    icon: colors.icon,
    additional: colors.additional,
    navigation: {
      navLink: {
        corner: borders.radius1,
        enabled: {
          name: colors.text.accent,
          icon: colors.icon.accent,
        },
        selected: {
          fill: colors.gradients.primary,
          name: colors.text.reversedPrimary,
          icon: colors.icon.reversedPrimary,
          stroke: colorNotUsed,
        },
        hovered: {
          fill: colors.base.grey300,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: colorNotUsed,
        },
        disabled: {
          fill: colors.base.grey100,
          name: colors.text.subtle,
          icon: colors.icon.subtle,
        },
      },
      textLink: {
        enabled: {
          text: colors.text.accentBright,
        },
        hovered: {
          text: colors.text.accent,
        },
        disabled: {
          text: colors.text.subtle,
        },
      },
      accountMenu: {
        divider: layout.divider300,
        corner: borders.radius1,
        enabled: {
          text: colors.text.accent,
          icon: colors.icon.accent,
        },
        selected: {
          fill: colors.gradients.primary,
          name: colors.text.reversedPrimary,
          icon: colors.icon.reversedPrimary,
          stroke: colorNotUsed,
        },
        hovered: {
          fill: colors.base.grey300,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: colorNotUsed,
        },
        focused: {
          fill: colors.base.grey500,
          name: colors.text.accent,
          icon: colors.icon.accent,
          stroke: colorNotUsed,
        },
        disabled: {
          fill: colors.base.grey100,
          name: colors.text.subtle,
          icon: colors.icon.subtle,
        },
      },
      topBar: {
        title: colors.text.accent,
      },
      logoLink: {
        name: colors.text.accent,
        divider: layout.divider300,
      },
      tab: {
        enabled: {
          name: colors.text.accentBright,
        },
        selected: {
          name: colors.text.accent,
          fill: colors.base.grey300,
        },
        hovered: {
          name: colors.text.accent,
          fill: colors.base.blueTransparent200,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colors.base.grey100,
        },
      },
    },
    pageElements: {
      menuPanel: {
        enabled: {
          background: colors.base.grey100,
          counter: colors.text.accentBright,
          title: colors.text.accent,
          description: colors.text.primary,
        },
        hovered: {
          background: colors.base.grey300,
          counter: colors.text.accentBright,
          title: colors.text.accent,
          description: colors.text.primary,
          icon: colors.icon.accent,
        },
        disabled: {
          background: colors.base.grey100,
          counter: colors.text.subtle,
          title: colors.text.subtle,
          description: colors.text.subtle,
        },
      },
      tooltip: {
        fill: layout.backgroundPrimary,
        text: colors.text.primary,
        stroke: colors.base.grey500,
      },
      dropdownMenu: {
        dropdownMenuShadow: shadows.dropShadow200,
      },
      dropdownMenuOption: {
        enabled: {
          name: colors.text.primary,
          description: colors.text.secondary,
        },
        hovered: {
          name: colors.text.primary,
          description: colors.text.secondary,
          background: colors.base.grey300,
        },
        selected: {
          name: colors.text.primary,
          description: colors.text.secondary,
          icon: colors.icon.primary,
        },
        disabled: {
          name: colors.text.subtle,
          description: colors.text.subtle,
        },
        enabledError: {
          name: colors.text.error,
          description: colors.text.secondary,
        },
        hoveredError: {
          name: colors.text.error,
          description: colors.text.secondary,
          background: colors.additional.red100,
        },
      },
      dropdownMenuSubsection: {
        name: colors.text.secondary,
      },
      table: {
        background: colors.base.grey100,
        corner: borders.radius1,
        border: colors.base.grey500,
        headerDivider: colors.base.grey500,
        rowDivider: colors.base.grey500,
        rowSelected: colors.base.grey100,
        headerCell: {
          enabled: {
            name: colors.text.accentBright,
            icon: colors.icon.accentBright,
          },
          hovered: {
            fill: colors.base.blueTransparent200,
            name: colors.text.accent,
            icon: colors.icon.accent,
          },
          disabled: {
            name: colors.text.subtle,
            icon: colors.icon.subtle,
          },
        },
      },
      flyOutNotifications: {
        dropdownMenuShadow: shadows.dropShadow200,
        corner: borders.radius2,
        title: colors.text.primary,
        description: colors.text.primary,
        backgroundInfo: colors.additional.blue100,
        backgroundSuccess: colors.additional.green100,
        backgroundWarning: colors.additional.yellow100,
        backgroundError: colors.additional.red100,
        backgroundService: colors.base.grey100,
        strokeInfo: colors.additional.blue500,
        strokeSuccess: colors.additional.green500,
        strokeWarning: colors.additional.yellow500,
        strokeError: colors.additional.red500,
        strokeService: colors.base.grey600,
      },
      notificationCard: {
        title: colors.text.primary,
        description: colors.text.primary,
        dateTime: colors.text.secondary,
        background: colors.base.grey100,
        stroke: colorNotUsed,
        corner: borders.radius2,
        rowsDistance: spacing * 2,
        fadingOverlay: colors.gradients.notificationCardOverlay,
      },
      indicator: {
        text: colors.text.reversedPrimary,
        fill: colors.additional.green500,
        corner: borders.radius2,
      },
      profileCard: {
        stroke: colorNotUsed,
        username: colors.text.accent,
        infoLabel: colors.text.secondary,
        infoText: colors.text.primary,
        infoDivider: colors.base.primary,
        background: colors.base.grey100,
      },
      serviceCard: {
        corner: borders.radius2,
        rowsDistance: spacing * 2,
        enabled: {
          name: colors.text.primary,
          fill: colors.base.grey100,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.primary,
          stroke: colorNotUsed,
        },
        hovered: {
          name: colors.text.primary,
          fill: colors.base.grey300,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.primaryHovered,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colors.base.grey100,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.subtle,
          stroke: colorNotUsed,
        },
        pressed: {
          name: colors.text.primary,
          fill: colors.base.grey500,
          emblemBackground: colors.base.white,
          proceedIcon: colors.icon.primaryHovered,
        },
      },
      versionMenu: {
        hovered: {
          stroke: colors.base.grey500,
        },
        pressed: {
          stroke: colors.base.primary,
        },
      },
      coloredBox: {
        background: colors.base.grey100,
        stroke: colorNotUsed,
      },
      accountType: {
        corner: borders.radius2,
        enabled: {
          name: colors.text.accentBright,
          fill: colors.base.grey100,
          stroke: colorNotUsed,
        },
        hovered: {
          name: colors.text.accent,
          fill: colors.base.grey300,
          stroke: colorNotUsed,
        },
        selected: {
          name: colors.text.accent,
          fill: colors.base.grey300,
          stroke: colors.base.primary,
        },
        disabled: {
          name: colors.text.subtle,
          fill: colors.base.grey100,
          stroke: colorNotUsed,
        },
      },
      logo: {
        enabled: {
          fill: colors.base.black,
        },
      },
      loader: {
        rotationUnit: colors.additional.teal500,
        body: colors.base.black,
        overlay: colors.base.whiteTransparent800,
        descriptionText: colors.text.primary,
        descriptionBackground: colors.base.white,
        descriptionCorner: borders.radius1,
      },
    },
    controls: {
      button: {
        primary: {
          enabled: {
            fill: colors.base.primary,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
          hovered: {
            fill: colors.base.blue500,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
          disabled: {
            fill: colors.base.grey100,
            name: colors.text.subtle,
            icon: colors.icon.subtle,
          },
          pressed: {
            fill: colors.base.blue800,
            name: colors.text.reversedPrimary,
            icon: colors.icon.reversedPrimary,
          },
        },
        secondary: {
          enabled: {
            stroke: colors.base.primary,
            name: colors.text.accentBright,
            icon: colors.icon.accentBright,
          },
          hovered: {
            fill: colors.base.blueTransparent200,
            stroke: colors.base.primary,
            name: colors.text.accent,
            icon: colors.icon.accent,
          },
          disabled: {
            stroke: colors.base.grey500,
            name: colors.text.subtle,
            icon: colors.icon.subtle,
          },
          pressed: {
            fill: colors.base.blueTransparent400,
            stroke: colors.base.blue800,
            name: colors.text.accent,
            icon: colors.icon.accent,
          },
        },
        tertiary: {
          enabled: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          hovered: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          disabled: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
          pressed: {
            fill: colors.base.primary,
            name: colors.base.primary,
            icon: colors.base.primary,
          },
        },
      },
      buttonText: {
        enabled: {
          name: colors.text.accentBright,
          icon: colors.icon.accentBright,
        },
        hovered: {
          fill: colors.base.blueTransparent200,
          name: colors.text.accent,
          icon: colors.icon.accent,
        },
        disabled: {
          name: colors.text.subtle,
          icon: colors.icon.subtle,
        },
        pressed: {
          name: colors.text.accent,
          icon: colors.icon.accent,
          fill: colors.base.blueTransparent400,
        },
      },
      buttonIcon: {
        enabled: {
          fill: colors.icon.accentBright,
        },
        hovered: {
          fill: colors.icon.accent,
          hoverArea: colors.base.blueTransparent200,
        },
        disabled: {
          fill: colors.icon.subtle,
        },
        pressed: {
          fill: colors.icon.accent,
          hoverArea: colors.base.blueTransparent400,
        },
      },
      options: {
        enabled: {
          text: colors.text.primary,
          icon: colors.icon.accentBright,
        },
        hovered: {
          text: colors.text.primary,
          icon: colors.icon.accentBright,
          hoverArea: colors.base.blueTransparent200,
        },
        pressed: {
          text: colors.text.primary,
          icon: colors.icon.accent,
          hoverArea: colors.base.blueTransparent400,
        },
        disabled: {
          text: colors.text.subtle,
          icon: colors.icon.subtle,
        },
        readOnly: {
          text: colors.text.primary,
          icon: colors.icon.subtle,
        },
        error: {
          text: colors.text.primary,
          icon: colors.icon.accentBright,
        },
      },
      chips: {
        enabled: {
          text: colors.text.accentBright,
          fill: colors.base.grey300,
        },
        hovered: {
          text: colors.text.accent,
          fill: colors.base.grey500,
        },
        disabled: {
          text: colors.text.subtle,
          fill: colors.base.grey100,
        },
        pressed: {
          text: colors.text.accent,
          fill: colors.base.grey600,
        },
      },
    },
    inputs: {
      label: {
        name: colors.text.secondary,
        requiredMark: colors.text.error,
      },
      footNote: {
        text: colors.text.secondary,
        icon: colors.icon.secondary,
        background: colorNotUsed,
      },
      errorMessage: {
        text: colors.text.error,
        icon: colors.icon.error,
      },
      inputField: {
        corner: borders.radius1,
        textRegular: colors.text.primary,
        textPlaceholder: colors.text.subtle,
        textDisabled: colors.text.subtle,
        textError: colors.text.primary,
        enabled: {
          stroke: colors.base.grey500,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        hovered: {
          stroke: colors.base.grey700,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        focused: {
          stroke: colors.base.blue500,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
        disabled: {
          fill: colors.base.grey100,
          stroke: colorNotUsed,
          prefixIcon: colors.icon.subtle,
          dropIcon: colors.icon.subtle,
        },
        readOnly: {
          fill: colors.base.grey100,
          stroke: colorNotUsed,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.subtle,
        },
        error: {
          stroke: colors.additional.red500,
          prefixIcon: colors.icon.secondary,
          dropIcon: colors.icon.primary,
        },
      },
      fileUpload: {
        progressIndicator: {
          fill: colors.base.grey300,
          corner: borders.radius1,
        },
        dropArea: {
          enabled: {
            border: colors.base.grey500,
          },
          hovered: {
            border: colors.base.grey700,
          },
        },
      },
      dateTimePicker: {
        dayCell: {
          corner: borders.radius1,
          enabled: {
            text: colors.text.primary,
            todayStroke: colors.base.primary,
          },
          hovered: {
            text: colors.text.primary,
            todayStroke: colors.base.primary,
            fill: colors.base.blueTransparent200,
          },
          selected: {
            text: colors.text.reversedPrimary,
            fill: colors.base.primary,
          },
          disabled: {
            text: colors.text.subtle,
            todayStroke: colors.base.primary,
          },
        },
        amPmSwitch: {
          corner: borders.radius1,
          enabled: {
            text: colors.text.primary,
          },
          hovered: {
            text: colors.text.primary,
            fill: colors.base.blueTransparent200,
          },
          pressed: {
            text: colors.text.primary,
            fill: colors.base.blueTransparent400,
          },
          disabled: {
            text: colors.text.subtle,
          },
        },
      },
    },
  },
};
